/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { filmographyCreditSchema } from '../person-credit-schema';
import { personPhotoSchema } from '../person-photo-schema';
import { personSchema } from '../person-schema';

export const personDetailSchema = z.object({
  person: personSchema,
  photos: z.array(personPhotoSchema),
  credits: z.array(filmographyCreditSchema),
});

export type IPersonDetail = z.infer<typeof personDetailSchema>;

export const getPersonResponseSchema = createApiResponseSchema(
  personDetailSchema,
) as import('zod').ZodSchema<IAPI<IPersonDetail>>;

export type IGetPersonResponse = IAPI<IPersonDetail>;
